// RV prefix = ReactViewer
// Add to all constants
var ReactViewer3DConstants = {
    RV_SET_ANNOTATIONS: 'RV_SET_ANNOTATIONS',
    RV_HIGHLIGHT_SCAN_POSITION: 'RV_HIGHLIGHT_SCAN_POSITION',
    RV_SET_MEASUREMENTS: 'RV_SET_MEASUREMENTS',
    RV_SET_ASSEMBLY_TEMPLATES: 'RV_SET_ASSEMBLY_TEMPLATES',
    RV_SET_ASSEMBLIES: 'RV_SET_ASSEMBLIES',
    RV_SET_ASSEMBLY_CREATION_TEMPLATE: 'RV_SET_ASSEMBLY_CREATION_TEMPLATE',
    RV_CLEAR_MEASUREMENTS: 'RV_CLEAR_MEASUREMENTS',
    RV_SET_MEASUREMENT_TYPE: 'RV_SET_MEASUREMENT_TYPE',
    RV_FOCUS_CAMERA: 'RV_FOCUS_CAMERA',
    RV_ZOOM_CAMERA: 'RV_ZOOM_CAMERA',
    RV_SET_CAMERA: 'RV_SET_CAMERA',
    RV_HIGHLIGHT_ASSETS: 'RV_HIGHLIGHT_ASSETS',
    RV_UNHIGHLIGHT_ASSETS: 'RV_UNHIGHLIGHT_ASSETS',
    RV_UNHIGHLIGHT_ALL_ASSETS: 'RV_UNHIGHLIGHT_ALL_ASSETS',
    RV_HIGHLIGHT_ASSET_SET_ASSETS: 'RV_HIGHLIGHT_ASSET_SET_ASSETS',
    RV_POPULATE_ASSET_SETS: 'RV_POPULATE_ASSET_SETS',
    RV_APPLY_ASSET_SET_MEMBERSHIP_DELTA: 'RV_APPLY_ASSET_SET_MEMBERSHIP_DELTA',
    RV_ASSET_SETS_POPULATED: 'RV_ASSET_SETS_POPULATED',
    RV_ASSET_SETS_COLORIZED: 'RV_ASSET_SETS_COLORIZED',
    RV_DISPLAY_KV_ASSET_SETS: 'RV_DISPLAY_KV_ASSET_SETS',
    RV_COLORIZE_ASSET_SETS: 'RV_COLORIZE_ASSET_SETS',
    RV_SET_ADVANCED_MATERIAL_TUNINGS: 'RV_SET_ADVANCED_MATERIAL_TUNINGS',
    RV_DESTROY_ASSET_SETS: 'RV_DESTROY_ASSET_SETS',
    RV_SET_VIEWER_CLICK_MODE: 'RV_SET_VIEWER_CLICK_MODE',
    RV_SET_SCAN_POSITIONS: 'RV_SET_SCAN_POSITIONS',
    RV_SET_SELECTED_ASSET_SET: 'RV_SET_SELECTED_ASSET_SET',
    RV_SET_RANGE_POSITION: 'RV_SET_RANGE_POSITION',
    RV_REFRESH_ASSET_SET_OCTREES: 'RV_REFRESH_ASSET_SET_OCTREES',
    RV_VIEWER_DATA_SETUP: 'RV_VIEWER_DATA_SETUP',
    RV_SET_ASSEMBLY_EDIT_MODE: 'RV_SET_ASSEMBLY_EDIT_MODE',
    RV_SET_TAG_EDIT_MODE: 'RV_SET_TAG_EDIT_MODE',
    RV_SET_VIEWER_CONFIGURATION: 'RV_SET_VIEWER_CONFIGURATION',
    RV_SET_CONTENT_LAYERS: 'RV_SET_CONTENT_LAYERS',
    RV_SET_VIEWER_SETTINGS: 'RV_SET_VIEWER_SETTINGS',
    RV_SET_SHOW_OCCLUDED_TAGS: 'RV_SET_SHOW_OCCLUDED_TAGS',
    RV_GET_SCREENSHOT: 'RV_GET_SCREENSHOT',
    RV_SCREENSHOT_READY: 'RV_SCREENSHOT_READY',
    RV_GET_PANORAMA: 'RV_GET_PANORAMA',
    RV_PANORAMA_READY: 'RV_PANORAMA_READY'
};

export default ReactViewer3DConstants;
